import * as React from 'react';
import {Dispatch} from 'redux';
import {connect} from 'react-redux';
import {ClassNameBuilder} from '@openfin/desktop-ui';

import {SetLaunchBarSize} from '../../../store/partials/LaunchBar';
import {LaunchBarSize} from '../../utils/constants';

import * as Styles from './Panel.module.scss';

interface Props {
    children: React.ReactNode;
    className?: string;
    initialState?: LaunchBarSize.EXPANDED | LaunchBarSize.NORMAL;
    setLaunchBarSize: (size: LaunchBarSize) => void;
    onBlur?: (event: React.FocusEvent) => void;
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
    setLaunchBarSize: (size: LaunchBarSize) => dispatch(new SetLaunchBarSize(size))
});

export const PanelComponent: React.FC<Props> = (props) => {
    const {children, className = '', initialState = LaunchBarSize.EXPANDED, setLaunchBarSize, onBlur} = props;

    React.useEffect(() => {
        setLaunchBarSize(initialState);
    }, []);

    return (
        <div className={ClassNameBuilder.join(Styles, 'panel', className)} onBlur={onBlur}>
            {children}
        </div>
    );
};

export const Panel = connect(undefined, mapDispatchToProps)(PanelComponent);
